const dashboardContent = {
  de: {
    sidebar: {
      dashboard: "Dashboard",
      qrManagement: "QR-Management",
      feedback: "Formular-Verwaltung",
      reports: "Berichte & Analysen",
      admin: "Admin Dashboard",
      settings: "Einstellungen",
      logout: "Logout",
      others: "Weitere",
    },
    dropdownUser: {
      profile: "Account Einstellungen",
      subscription: "Abo Verwaltung",
      support: "Support",
      logout: "Abmelden",
    },
    dropdownNotification: {
      title: "Benachrichtigungen",
      markAllRead: "Alle als gelesen markieren",
      unread: (count) => `Ungelesen (${count})`,
      noUnread: "Keine ungelesenen Nachrichten",
      viewAll: "Alle Benachrichtigungen anzeigen",
      justNow: "Gerade eben",
      hoursAgo: (h) => `Vor ${h} Stunden`,
    },
    home: {
      detailsModal: {
        title: "Feedback Details",
        formLabel: "Feedbackformular",
        fromLabel: "Von",
        ratingLabel: "Gesamtbewertung",
        unknownForm: "Unbekannt",
        unknownUser: "Unbekannt",
        notAvailable: "N/A",
      },
      tips: {
        title: "Tipps",
        list: [
          "Nutzen Sie personalisierte QR-Codes für Ihr Feedback-Formular.",
          "Analysieren Sie Trends in den Feedbacks, um Ihr Angebot zu verbessern.",
          "Passen Sie das Formular an Ihr Unternehmen und Ihre Marke an.",
          "Nutzen Sie optional unser Gewinnspiel-Tool für potenziell mehr wertvolles Feedback.",
        ],
      },
      metrics: {
        allFeedback: "Gesamtes Feedback",
        avgRating: "Durchschnittliche Bewertung",
        activeForms: "Aktive Formulare",
        thisWeek: "Feedback diese Woche",
      },
      table: {
        title: "Letztes Feedback",
        columnForm: "Für Feedbackformular",
        columnFrom: "von",
        columnRating: "Gesamtbewertung",
        columnAction: "Aktion",
        actionShow: "Anzeigen",
        emptyText: "Es ist noch kein Feedback eingegangen.",
      },
      quickActionsTitle: "Schnell Aktionen",
      quickActions: [
        {
          title: "Neues Formular",
          description: "Erstellen Sie ein neues Feedback Formular",
          buttonText: "Erstellen",
        },
        {
          title: "QR Code",
          description:
            "Erstellen Sie ein QR Code und verknüpfen Sie das Formular mit ihrem QR Code",
          buttonText: "QR Code erstellen",
        },
        {
          title: "Berichte",
          description: "Generieren Sie Berichte und Analysen",
          buttonText: "zu den Berichten",
        },
        {
          title: "Statistiken",
          description: "Schauen Sie sich Statistiken zu Ihrem Feedback an.",
          buttonText: "zu den Statistiken",
        },
        {
          title: "Einstellungen",
          description: "Passen Sie Ihre Dashboard-Einstellungen an",
          buttonText: "Einstellungen öffnen",
        },
      ],
    },
    settings: {
      title: "Einstellungen",
      description: "Passe deine Kontoeinstellungen an.",
      tabs: {
        profile: "Profil",
        subscription: "Abonnement",
        notifications: "Benachrichtigungen",
        language: "Sprache",
        other: "Sonstiges",
      },
      profile: {
        title: "Profil-Einstellungen",
        name: "Name",
        email: "E-Mail",
        password: "Neues Passwort",
        save: "Ändern",
      },
      subscription: {
        title: "Abonnement verwalten",
        plan: "Plan:",
        status: "Status:",
        startDate: "Startdatum:",
        currentPeriodEnd: "Laufzeit bis:",
        nextBillingDate: "Nächste Abrechnung:",
        contractDuration: "Vertragslaufzeit:",
        pendingCancellation: "Kündigungsstatus:",
        button: "Abonnement verwalten",
      },
      notifications: {
        title: "Benachrichtigungseinstellungen",
        email: "E-Mail-Benachrichtigungen",
        app: "App-Benachrichtigungen",
      },
      other: {
        title: "Sonstiges",
        export: "Meine Daten exportieren",
        delete: "Konto löschen",
        confirmTitle: "Willst du dein Konto wirklich löschen?",
        confirmDelete: "Dieser Vorgang kann nicht rückgängig gemacht werden.",
        confirmYes: "Ja, löschen",
        confirmCancel: "Abbrechen",
        deleted: "Konto erfolgreich gelöscht.",
      },
    },
    qr: {
      title: "QR-Code-Management",
      createButton: "+ Neuer QR-Code",
      createmodal: {
        title: "Neuen QR-Code erstellen",
        nameLabel: "QR-Code Name",
        namePlaceholder: "Name des QR-Codes",
        formLabel: "Feedback-Formular",
        formPlaceholder: "Formular auswählen",
        logoLabel: "Logo hochladen (optional)",
        logoButton: "Logo auswählen",
        cancel: "Abbrechen",
        create: "Erstellen",
        creating: "Erstellen...",
      },
      editModal: {
        title: "QR-Code bearbeiten",
        nameLabel: "Name",
        namePlaceholder: "Name des QR-Codes",
        nameRequired: "Bitte einen Namen eingeben!",
        urlLabel: "Ziel-URL",
        urlPlaceholder: "https://example.com",
        urlRequired: "Bitte eine URL eingeben!",
        save: "Speichern",
      },
      deleteModal: {
        title: "QR-Code löschen",
        text: "Möchten Sie den QR-Code",
        confirm: "wirklich löschen?",
        cancel: "Abbrechen",
        delete: "Löschen",
      },
      list: {
        tableTitle: "QR-Code-Übersicht",
        tableFooter: (count, max) =>
          `${count} QR-Codes vorhanden von maximal ${max}`,
        emptyText:
          "Sie haben noch kein QR Code erstellt. Erstellen Sie einen und verbinden Sie Ihr Formular damit.",
        name: "Name",
        form: "Feedback Formular",
        status: "Status",
        createdAt: "Erstellt am",
        actions: "Aktionen",
        show: "Anzeigen",
        edit: "Bearbeiten",
        delete: "Löschen",
        viewTitle: "QR-Code anzeigen",
        download: "Herunterladen",
        close: "Schließen",
      },
    },
    feedback: {
      stats: {
        activeForms: "Aktive Formulare",
        totalFeedback: "Gesamtes Feedback",
        averageRating: "Durchschnittliche Bewertung",
      },
      button: "Neues Formular erstellen",
      messages: {
        deleteSuccess: "Formular erfolgreich gelöscht.",
        deleteError: "Fehler beim Löschen des Formulars.",
      },
      deleteModal: {
        title: "Formular löschen",
        confirm: "Sind Sie sicher, dass Sie dieses Formular löschen möchten?",
        warning: "Diese Aktion kann nicht rückgängig gemacht werden.",
        cancel: "Abbrechen",
        delete: "Löschen",
      },
      card: {
        view: "Formular anzeigen",
        edit: "Formular bearbeiten",
        delete: "Formular löschen",
        received: "Feedback erhalten",
      },
      list: {
        empty: "Noch keine Formulare vorhanden. Erstellen Sie eins.",
      },
      modal: {
        titleCreate: "Neues Formular erstellen",
        titleEdit: "Formular bearbeiten",
        nameLabel: "Name des Formulars",
        namePlaceholder: "Name des Formulars",
        descriptionLabel: "Kundenansprache",
        descriptionPlaceholder:
          "Gib hier einen kurzen Begrüßungstext ein. Verweise eventuell auch auf die Kürze/Länge des Formulares. Dies verhilft oftmals dazu, dass mehr Kunden das Formular ausfüllen.",
        statusLabel: "Status",
        statusPlaceholder: "Status auswählen",
        statusActive: "Aktiv",
        statusInactive: "Inaktiv",
        designLabel: "Design auswählen",
        colorLabel: "Farbe auswählen",
        logoLabel: "Logo hochladen",
        uploadButton: "Logo hochladen",
        uploadError: "Bitte nur Bilddateien hochladen!",
        questionAddTitle: "FRAGE HINZUFÜGEN",
        questionLabel: "Fragen hinzufügen",
        addText: "Freitext hinzufügen",
        addMC: "Multiple Choice hinzufügen",
        addStar: "Star Rating hinzufügen",
        dynamicInfo: "Ja / Nein Fragen mit Follow Up",
        chooseYesNo: "Bitte Ja oder Nein wählen",
        enterReason: "Bitte Begründung eingeben",
        questionPlaceholder: "Frage",
        questionTypeLabel: "Typ",
        questionTypeText: "Freitext",
        questionTypeMC: "Multiple Choice",
        questionTypeStar: "Star Rating",
        optionPlaceholder: "Option",
        addOption: "Option hinzufügen",
        addDynamic: "Dynamisch",
        cancel: "Abbrechen",
        create: "Erstellen",
        update: "Aktualisieren",
        formNameRequired: "Bitte geben Sie einen Namen ein.",
        formDescriptionRequired: "Bitte geben Sie eine Beschreibung ein.",
        formStatusRequired: "Bitte wählen Sie einen Status aus.",
        questionRequired: "Bitte geben Sie eine Frage ein.",
        typeRequired: "Bitte wählen Sie einen Fragetyp aus.",
        optionRequired: "Bitte geben Sie eine Option ein.",
        logoUploadLoading: "Logo wird hochgeladen...",
        logoUploadSuccess: "Logo erfolgreich hochgeladen!",
        logoUploadError: "Fehler beim Hochladen des Logos",
        designTitlePrefix: "Design",
        uploadFileDefaultName: "Hochgeladenes Logo",
        formCreateSuccess: "Formular erstellt.",
        formCreateError: "Fehler beim Erstellen des Formulars",
        formUpdateError: "Fehler beim Updaten des Formulars",
        formUpdateSuccess: "Formular geupdatet.",
        photosLabel: "Erlauben Fotos anzuhängen",
        googleReviewToggleLabel: "Weiterleitung zu Google Bewertung aktivieren",
        googleReviewUrlLabel: "Link zu deinem Google Unternehmensprofil",
        googleReviewUrlPlaceholder: "https://g.page/yourbusiness",
        googleReviewUrlRequired: "Bitte gib den Google-Link ein",
        googleReviewUrlInvalid: "Bitte gib eine gültige URL ein",
        languageLabel: "Sprache",
        languagePlaceholder: "Bitte Sprache wählen",
        languageRequired: "Bitte eine Sprache wählen",
      },
    },
    reports: {
      analysis: {
        titleFeedbackAnalysis: "Feedback-Analysen",
        titleReportGeneration: "Feedback-Bericht generieren",
        formSelectLabel: "Formular auswählen:",
        formSelectPlaceholder: "Formular wählen",
        exportButtonLabel: "Bericht als PDF exportieren",
        periodError:
          "Bitte wählen Sie einen Berichtstyp und einen Zeitraum aus.",
        formError: "Bitte wählen Sie ein Formular aus.",
        table: {
          name: "Name",
          date: "Datum",
          from: "Von",
          to: "Bis",
          action: "Aktion",
          download: "Download",
        },
        dateRanges: {
          last7Days: "Letzte 7 Tage",
          last30Days: "Letzte 30 Tage",
        },
        thisYear: "Dieses Jahr",
        lastReportsTitle: "Deine letzten Berichte",
        lastReportsEmpty:
          "Sie haben noch kein Bericht erstellt. Erstellen Sie einen.",

        titleFeedbackTrends: "Feedback-Trends",
        titleFeedbackDistribution: "Feedback-Verteilung",
        positiveFeedback: "Positiv",
        neutralFeedback: "Neutral",
        negativeFeedback: "Negativ",
        loadingData: "Lade Daten...",
        totalFeedbacks: "Gesamtes Feedback",
        positiveFeedbacks: "Positive Feedbacks",
        averageRating: "Durchschnittliche Bewertung",
        activeForms: "Aktive Formulare",
        errorLoadingData: "Fehler beim Laden der KPI-Daten.",
        noDataAvailable: "Keine Daten verfügbar.",
        error: "Fehler",
        formRankingTitle: "Ranking der Formulare",
        noFormsToRank:
          "Sie haben noch keine Formulare die wir ranken könnten. Erstellen Sie ein Formular.",
        kiSuggestionsTitle: "KI-Verbesserungsvorschläge",
        kiFetchInfo: "Einmal im Monat kannst du neue KI-Vorschläge abrufen!",
        kiFetchWarning:
          "Du kannst nur einmal im Monat neue Vorschläge abrufen!",
        kiFetchSuccess: "Neue Vorschläge wurden abgerufen!",
        kiFetchButton: "Neue Vorschläge abrufen",
        titleFeedbackReport: "Gesamtbericht – Alle Formulare",
        descriptionFeedbackReport:
          "Eine Zusammenfassung aller gesammelten Feedbacks mit KI-Analyse.",
        viewReport: "Bericht ansehen",
        titleIndividualReport: "Individueller Bericht – Pro Formular",
        descriptionIndividualReport:
          "Detaillierte Analysen und Bewertungen für jedes einzelne Formular.",
        selectForm: "Formular wählen",
        titleAIReport: "KI-Analyse – Alle Formulare",
        descriptionAIReport:
          "Automatische Verbesserungsvorschläge aller gesammelten Feedbacks.",
        startAIAnalysis: "KI-Analyse starten",
        titleAISingleReport: "KI-Analyse – Einzelne Formulare",
        descriptionAISingleReport:
          "Individuelle KI-Optimierungsvorschläge für spezifische Formulare.",
        selectFormAI: "Formular wählen",
      },
    },
    subscriptionOverlay: {
      title: "Premium Feature",
      description: "Upgrade dein Abo um dieses Feature zu nutzen.",
      upgradeButton: "Upgrade jetzt",
    },
    upgradeCard: {
      title: "Upgrade dein Abo",
      description:
        "Schalte alle Funktionen frei und hebe dein Erlebnis auf die nächste Stufe!",
      upgradeButton: "Upgrade jetzt",
    },
    supportTicketForm: {
      title: "Erstelle dein Support Ticket",
      subjectLabel: "Titel",
      descriptionLabel: "Beschreibung",
      topicLabel: "Thema",
      subjectRequired: "Gibt einen Titel ein",
      descriptionRequired: "Beschreibe dein Problem",
      topicRequired: "Wähle ein Thema aus",
      topicSystem: "Technisch",
      topicInvoice: "Rechnung",
      topicAccount: "Account",
      topicFeature: "Verbesserungsvorschläge",
      topicOther: "Sonstiges",
      submitButton: "Ticket Absenden",
    },
    notifications: {
      title: "Benachrichtigungen",
      filterAll: "Alle",
      filterUnread: "Ungelesen",
      filterRead: "Gelesen",
      markSelectedAsRead: "Ausgewählte als gelesen markieren",
      noNotifications: "Keine Benachrichtigungen vorhanden",
      markAsRead: "Als gelesen markieren",
    },
    profile: {
      profile: "Profil",
      profileImage: "Profilbild ändern",
      nameLabel: "Name",
      emailLabel: "E-Mail",
      changeEmail: "Ändern",
      passwordLabel: "Passwort",
      changePassword: "Ändern",
      bioLabel: "Über mich",
      saveChanges: "Änderungen speichern",
      emailChangeTitle: "E-Mail ändern",
      newEmail: "Neue E-Mail",
      confirmNewEmail: "Neue E-Mail bestätigen",
      passwordChangeTitle: "Passwort ändern",
      newPassword: "Neues Passwort",
      confirmNewPassword: "Neues Passwort bestätigen",
      save: "Speichern",
      cancel: "Abbrechen",
      emailError: "Die eingegebenen E-Mail-Adressen stimmen nicht überein.",
      passwordError: "Die eingegebenen Passwörter stimmen nicht überein.",
    },
    subscription: {
      title: "Abonnement verwalten",
      plan: "Plan:",
      status: "Status:",
      startDate: "Startdatum:",
      currentPeriodEnd: "Laufzeit bis:",
      nextBillingDate: "Nächste Abrechnung:",
      contractDuration: "Vertragslaufzeit:",
      pendingCancellation: "Kündigungsstatus:",
      cancelButton: "Abonnement kündigen",
      upgradeButton: "Upgrade durchführen",
      manageButton: "Abrechnung & Zahlungsdetails",
      confirmTitle: "Möchtest du wirklich",
      confirmAction: "durchführen",
      confirmContent: "Diese Aktion kann nicht rückgängig gemacht werden.",
      yes: "Ja",
      no: "Nein",
      cancel: "Kündigung",
      cancelSuccess: "Abonnement wurde erfolgreich gekündigt.",
      upgrade: "Upgrade",
      upgradeSuccess: "Upgrade erfolgreich durchgeführt.",
    },
    subscriptionPage: {
      title: "Wähle dein Abo",
      infoText:
        "Die Auswahl zwischen monatlich und jährlich betrifft nur die Vertragslaufzeit. Der Abrechnungszeitraum bleibt immer monatlich. Bei einer jährlichen Laufzeit profitierst du von günstigeren Preisen.",
      monthly: "Monatlich",
      annual: "Jährlich",
      monthlyPeriod: "Monat",
      annualPeriod: "Monat (12 Monate Laufzeit)",
      selectButton: "Jetzt auswählen",
      agbText: "Ich akzeptiere die {agb} und {datenschutz}.",
      agbLink: "/agbs",
      datenschutzLink: "/privacypolicy",
      plans: [
        {
          name: "BASIC",
          monthlyPrice: 19.9,
          annualPrice: 14.9,
          features: [
            "1 Feedback-Formular",
            "1 QR-Code",
            "Basis-Reports",
            "Ohne Branding",
            "Keine KI-Funktionen",
          ],
        },
        {
          name: "STANDARD",
          monthlyPrice: 29.9,
          annualPrice: 24.9,
          features: [
            "5 Feedback-Formulare",
            "5 QR-Codes",
            "Eigenes Branding",
            "Detaillierte Analysen",
            "Monatliche KI-Empfehlungen",
          ],
        },
        {
          name: "PREMIUM",
          monthlyPrice: 39.9,
          annualPrice: 34.9,
          features: [
            "10 Feedback-Formulare",
            "10 QR-Codes",
            "Erweiterte KI-Analysen",
            "Eigenes Branding",
            "Monatliche KI-Empfehlungen",
          ],
        },
      ],
    },
    cancelPage: {
      title: "Payment Cancelled",
      message: "Your payment was not completed. You can try again.",
      buttonText: "Back to Subscription Page",
    },
    successPage: {
      title: "Zahlung erfolgreich!",
      message: "Danke für deinen Kauf. Dein Abo ist jetzt aktiv.",
      redirecting: "Du wirst gleich weitergeleitet…",
      stayOpen:
        "Bitte diese Seite geöffnet lassen, bis die Weiterleitung erfolgt.",
      buttonText: "Jetzt zum Dashboard",
    },
    feedbackSummary: {
      title: "Alle Feedbacks",
      table: {
        columnForm: "Formular",
        columnFrom: "Von",
        columnRating: "Bewertung",
        columnAction: "Aktion",
        actionShow: "Anzeigen",
        emptyText: "Keine Einträge gefunden",
      },
    },
  },
  en: {
    sidebar: {
      dashboard: "Dashboard",
      qrManagement: "QR Management",
      feedback: "Form Management",
      reports: "Reports & Analytics",
      admin: "Admin Dashboard",
      settings: "Settings",
      logout: "Logout",
      others: "Others",
    },
    dropdownUser: {
      profile: "Account Settings",
      subscription: "Subscription",
      support: "Support",
      logout: "Log Out",
    },
    dropdownNotification: {
      title: "Notifications",
      markAllRead: "Mark all as read",
      unread: (count) => `Unread (${count})`,
      noUnread: "No unread notifications",
      viewAll: "View all notifications",
      justNow: "Just now",
      hoursAgo: (h) => `${h} hours ago`,
    },
    home: {
      detailsModal: {
        title: "Feedback Details",
        formLabel: "Feedback Form",
        fromLabel: "From",
        ratingLabel: "Overall Rating",
        unknownForm: "Unknown",
        unknownUser: "Unknown",
        notAvailable: "N/A",
      },
      tips: {
        title: "Tips",
        list: [
          "Use personalized QR codes for your feedback form.",
          "Analyze feedback trends to improve your offering.",
          "Customize the form to match your company and brand.",
          "Optionally use our contest tool for potentially more valuable feedback.",
        ],
      },
      metrics: {
        allFeedback: "Total Feedback",
        avgRating: "Average Rating",
        activeForms: "Active Forms",
        thisWeek: "Feedback this Week",
      },
      table: {
        title: "Latest Feedback",
        columnForm: "Feedback Form",
        columnFrom: "From",
        columnRating: "Rating",
        columnAction: "Action",
        actionShow: "Show",
        emptyText: "No feedback has been received yet.",
      },
      quickActionsTitle: "Quick Actions",
      quickActions: [
        {
          title: "New Form",
          description: "Create a new feedback form",
          buttonText: "Create",
        },
        {
          title: "QR Code",
          description: "Generate a QR code and link it to your feedback form",
          buttonText: "Generate QR Code",
        },
        {
          title: "Reports",
          description: "Generate reports and analytics",
          buttonText: "View Reports",
        },
        {
          title: "Statistics",
          description: "View statistics about your feedback",
          buttonText: "View Stats",
        },
        {
          title: "Settings",
          description: "Adjust your dashboard settings",
          buttonText: "Open Settings",
        },
      ],
    },
    settings: {
      title: "Settings",
      description: "Adjust your account preferences.",
      tabs: {
        profile: "Profile",
        subscription: "Subscription",
        notifications: "Notifications",
        language: "Language",
        other: "Other",
      },
      profile: {
        title: "Profile Settings",
        name: "Name",
        email: "Email",
        password: "New Password",
        save: "Change",
      },
      subscription: {
        title: "Manage Subscription",
        plan: "Plan:",
        status: "Status:",
        startDate: "Start Date:",
        currentPeriodEnd: "Valid Until:",
        nextBillingDate: "Next Billing Date:",
        contractDuration: "Contract Duration:",
        pendingCancellation: "Cancellation Status:",
        button: "Manage Subscription",
      },
      notifications: {
        title: "Notification Settings",
        email: "Email Notifications",
        app: "App Notifications",
      },
      other: {
        title: "Other",
        export: "Export my data",
        delete: "Delete account",
        confirmTitle: "Do you really want to delete your account?",
        confirmDelete:
          "This action cannot be undone. All your data will be lost.",
        confirmYes: "Yes, delete",
        confirmCancel: "Cancel",
        deleted: "Account successfully deleted.",
      },
    },
    qr: {
      title: "QR Code Management",
      createButton: "+ New QR Code",
      createmodal: {
        title: "Create New QR Code",
        nameLabel: "QR Code Name",
        namePlaceholder: "Enter QR code name",
        formLabel: "Feedback Form",
        formPlaceholder: "Select a form",
        logoLabel: "Upload logo (optional)",
        logoButton: "Choose Logo",
        cancel: "Cancel",
        create: "Create",
        creating: "Creating...",
      },
      editModal: {
        title: "Edit QR Code",
        nameLabel: "Name",
        namePlaceholder: "QR code name",
        nameRequired: "Please enter a name!",
        urlLabel: "Target URL",
        urlPlaceholder: "https://example.com",
        urlRequired: "Please enter a URL!",
        save: "Save",
      },
      deleteModal: {
        title: "Delete QR Code",
        text: "Do you really want to delete the QR code",
        confirm: "?",
        cancel: "Cancel",
        delete: "Delete",
      },
      list: {
        tableTitle: "QR Code Overview",
        tableFooter: (count, max) => `${count} QR codes used out of ${max}`,
        emptyText:
          "You haven't created any QR codes yet. Create one and link it to your form.",
        name: "Name",
        form: "Feedback Form",
        status: "Status",
        createdAt: "Created At",
        actions: "Actions",
        show: "View",
        edit: "Edit",
        delete: "Delete",
        viewTitle: "View QR Code",
        download: "Download",
        close: "Close",
      },
    },
    feedback: {
      stats: {
        activeForms: "Active Forms",
        totalFeedback: "Total Feedback",
        averageRating: "Average Rating",
      },
      button: "Create New Form",
      messages: {
        deleteSuccess: "Form deleted successfully.",
        deleteError: "Error deleting the form.",
      },
      deleteModal: {
        title: "Delete Form",
        confirm: "Are you sure you want to delete this form?",
        warning: "This action cannot be undone.",
        cancel: "Cancel",
        delete: "Delete",
      },
      card: {
        view: "View Form",
        edit: "Edit Form",
        delete: "Delete Form",
        received: "Feedback received",
      },
      list: {
        empty: "No forms available yet. Create one to get started.",
      },
      modal: {
        titleCreate: "Create New Form",
        titleEdit: "Edit Form",
        nameLabel: "Form Name",
        namePlaceholder: "Name of the form",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Description of the form",
        statusLabel: "Status",
        statusPlaceholder: "Select status",
        statusActive: "Active",
        statusInactive: "Inactive",
        designLabel: "Select Design",
        colorLabel: "Select Color",
        questionLabel: "Fragen hinzufügen",
        addDynamic: "Dynamic",
        dynamicInfo: "Yes / No question with follow up",
        logoLabel: "Upload Logo",
        uploadButton: "Upload Logo",
        uploadError: "Please upload image files only!",
        questionAddTitle: "ADD QUESTION",
        addText: "Add Free Text",
        addMC: "Add Multiple Choice",
        chooseYesNo: "Please Select Yes Or No",
        enterReason: "Enter you Reason",
        addStar: "Add Star Rating",
        questionPlaceholder: "Question",
        questionTypeLabel: "Type",
        questionTypeText: "Free Text",
        questionTypeMC: "Multiple Choice",
        questionTypeStar: "Star Rating",
        optionPlaceholder: "Option",
        addOption: "Add Option",
        cancel: "Cancel",
        create: "Create",
        update: "Update",
        formNameRequired: "Please enter a name.",
        formDescriptionRequired: "Please enter a description.",
        formStatusRequired: "Please select a status.",
        questionRequired: "Please enter a question.",
        typeRequired: "Please select a question type.",
        optionRequired: "Please enter an option.",
        logoUploadLoading: "Uploading logo...",
        logoUploadSuccess: "Logo uploaded successfully!",
        logoUploadError: "Error uploading logo",
        designTitlePrefix: "Design",
        uploadFileDefaultName: "Uploaded Logo",
        formCreateSuccess: "Form created successfully.",
        formCreateError: "Error creating form.",
        formUpdateError: "Error updating form.",
        formUpdateSuccess: "Form updated successfully.",
        photosLabel: "Allow add photos",
        googleReviewToggleLabel: "Enable redirect to Google Review",
        googleReviewUrlLabel: "Link to your Google Business Profile",
        googleReviewUrlPlaceholder: "https://g.page/yourbusiness",
        googleReviewUrlRequired: "Please enter your Google Review link",
        googleReviewUrlInvalid: "Please enter a valid URL",
        languageLabel: "Language",
        languagePlaceholder: "Please choose language",
        languageRequired: "Please choose language",
      },
    },
    reports: {
      analysis: {
        titleFeedbackAnalysis: "Feedback Analysis",
        titleReportGeneration: "Generate Feedback Report",
        formSelectLabel: "Select Form:",
        formSelectPlaceholder: "Choose form",
        exportButtonLabel: "Export Report as PDF",
        periodError: "Please select a report type and time range.",
        formError: "Please select a form.",
        dateRanges: {
          last7Days: "Last 7 Days",
          last30Days: "Last 30 Days",
          thisYear: "This Year",
        },
        lastReportsTitle: "Your Recent Reports",
        lastReportsEmpty:
          "You haven't generated any reports yet. Create one to get started.",
        table: {
          name: "Name",
          date: "Date",
          from: "From",
          to: "To",
          action: "Action",
          download: "Download",
        },
        titleFeedbackTrends: "Feedback Trends",
        titleFeedbackDistribution: "Feedback Distribution",
        positiveFeedback: "Positive",
        neutralFeedback: "Neutral",
        negativeFeedback: "Negative",
        loadingData: "Loading data...",
        totalFeedbacks: "Total Feedbacks",
        positiveFeedbacks: "Positive Feedbacks",
        averageRating: "Average Rating",
        activeForms: "Active Forms",
        errorLoadingData: "Error loading KPI data.",
        noDataAvailable: "No data available.",
        error: "Error",
        formRankingTitle: "Form Ranking",
        noFormsToRank: "You don't have any forms to rank yet. Create a form.",
        kiSuggestionsTitle: "AI Improvement Suggestions",
        kiFetchInfo: "You can fetch new AI suggestions once a month!",
        kiFetchWarning: "You can only fetch new suggestions once a month!",
        kiFetchSuccess: "New suggestions fetched!",
        kiFetchButton: "Fetch New Suggestions",
        titleFeedbackReport: "Aggregated Report – All Forms",
        descriptionFeedbackReport:
          "A summary of all collected feedback with AI analysis.",
        viewReport: "View Report",
        titleIndividualReport: "Individual Report – Per Form",
        descriptionIndividualReport:
          "Detailed analysis and evaluations for each individual form.",
        selectForm: "Select Form",
        titleAIReport: "AI Analysis – All Forms",
        descriptionAIReport:
          "Automatic improvement suggestions for all collected feedback.",
        startAIAnalysis: "Start AI Analysis",
        titleAISingleReport: "AI Analysis – Individual Forms",
        descriptionAISingleReport:
          "Individual AI optimization suggestions for specific forms.",
        selectFormAI: "Select Form",
      },
    },
    subscriptionOverlay: {
      title: "Premium Feature",
      description: "Upgrade your subscription to use this feature.",
      upgradeButton: "Upgrade Now",
    },
    upgradeCard: {
      title: "Upgrade your subscription",
      description:
        "Unlock all features and take your experience to the next level!",
      upgradeButton: "Upgrade Now",
    },
    supportTicketForm: {
      title: "Create your Support Ticket",
      subjectLabel: "Title",
      descriptionLabel: "Description",
      topicLabel: "Topic",
      subjectRequired: "Please enter a title",
      descriptionRequired: "Please describe your issue",
      topicRequired: "Please select a topic",
      topicSystem: "Technical",
      topicInvoice: "Invoice",
      topicAccount: "Account",
      topicFeature: "Feature Requests",
      topicOther: "Other",
      submitButton: "Submit Ticket",
    },
    notifications: {
      title: "Notifications",
      filterAll: "All",
      filterUnread: "Unread",
      filterRead: "Read",
      markSelectedAsRead: "Mark selected as read",
      noNotifications: "No notifications available",
      markAsRead: "Mark as read",
    },
    profile: {
      profile: "Profile",
      profileImage: "Change profile picture",
      nameLabel: "Name",
      emailLabel: "Email",
      changeEmail: "Change",
      passwordLabel: "Password",
      changePassword: "Change",
      bioLabel: "About me",
      saveChanges: "Save changes",
      emailChangeTitle: "Change Email",
      newEmail: "New Email",
      confirmNewEmail: "Confirm New Email",
      passwordChangeTitle: "Change Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      save: "Save",
      cancel: "Cancel",
      emailError: "The entered email addresses do not match.",
      passwordError: "The entered passwords do not match.",
    },
    subscription: {
      title: "Manage Subscription",
      plan: "Plan:",
      status: "Status:",
      startDate: "Start Date:",
      currentPeriodEnd: "Valid Until:",
      nextBillingDate: "Next Billing Date:",
      contractDuration: "Contract Duration:",
      pendingCancellation: "Cancellation Status:",
      cancelButton: "Cancel Subscription",
      upgradeButton: "Upgrade Subscription",
      manageButton: "Payment Methods & Invoices",
      confirmTitle: "Do you really want to",
      confirmAction: "perform this action",
      confirmContent: "This action cannot be undone.",
      yes: "Yes",
      no: "No",
      cancel: "Cancel Subscription",
      cancelSuccess: "Subscription has been successfully cancelled.",
      upgrade: "Upgrade",
      upgradeSuccess: "Upgrade completed successfully.",
    },
    subscriptionPage: {
      title: "Choose your subscription",
      infoText:
        "The selection between monthly and annual only affects the contract duration. The billing period remains monthly. With an annual duration, you benefit from lower prices.",
      monthly: "Monthly",
      annual: "Annually",
      monthlyPeriod: "Month",
      annualPeriod: "Month (12 months duration)",
      selectButton: "Select now",
      plans: [
        {
          name: "BASIC",
          monthlyPrice: 19.9,
          annualPrice: 14.9,
          features: [
            "1 feedback form",
            "1 QR code",
            "Basic reports",
            "No branding",
            "No AI features",
          ],
        },
        {
          name: "STANDARD",
          monthlyPrice: 29.9,
          annualPrice: 24.9,
          features: [
            "5 feedback forms",
            "5 QR codes",
            "Custom branding",
            "Detailed analytics",
            "Monthly AI recommendations",
          ],
        },
        {
          name: "PREMIUM",
          monthlyPrice: 39.9,
          annualPrice: 34.9,
          features: [
            "10 feedback forms",
            "10 QR codes",
            "Advanced AI reports",
            "Custom branding",
            "Monthly AI recommendations",
          ],
        },
      ],
      agbText: "I accept the {agb} and {datenschutz}.",
      agbLink: "/agbs",
      datenschutzLink: "/privacypolicy",
    },
    cancelPage: {
      title: "Payment Cancelled",
      message: "Your payment was not completed. You can try again.",
      buttonText: "Back to Subscription Page",
    },
    successPage: {
      title: "Payment Successful!",
      message: "Thank you for your purchase. Your subscription is now active.",
      redirecting: "Redirecting shortly…",
      stayOpen: "Please keep this page open until you’re redirected.",
      buttonText: "Go to Dashboard Now",
    },
    feedbackSummary: {
      title: "All Feedbacks",
      table: {
        columnForm: "Form",
        columnFrom: "From",
        columnRating: "Rating",
        columnAction: "Action",
        actionShow: "Show",
        emptyText: "No entries found",
      },
    },
  },
};

export default dashboardContent;
